import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'

const StSelectListContainer = styled(FlexColumn)`
  gap: ${({ theme }) => theme.UI.SpacingPx.Space3};
`

export { StSelectListContainer }
